import ManageVars from "@/app/manageVars/pages/ManageVars.vue";
import ConnectorCreatePage from "@/app/ivr/pages/ConnectorCreatePage.vue";
import ConnectorEditPage from "@/app/ivr/pages/ConnectorEditPage.vue";

export default [
  {
    path: "/flows/utility",
    name: "utility",
    component: ManageVars,
    children: [
      {
        path: "create",
        name: "create-connector",
        component: ConnectorCreatePage,
        meta: {
          requiresAuth: true,
          useSubmenu: false,
        },
      },
      {
        path: ":connectorId",
        name: "edit-connector",
        component: ConnectorEditPage,
        meta: {
          requiresAuth: true,
          useSubmenu: false,
        },
      },
    ],
    meta: {
      requiresAuth: true,
      useSubmenu: true
    },
  },
];
